module.exports = __webpack_public_path__ + "static/media/summer-castel.8c32e05b.jpg";